import InputWithMask from './InputWithMask';

export default InputWithMask;
